import { BLOCKING_OVERLAY, isVisible } from "./morph_state"

const LULL = 5_000
const BUSY_EVENTS = ["click", "contextmenu", "keydown", "input", "submit"]
const SELECTED = "[data-selection-target='checkbox']:checked"
const EDITABLE = ["INPUT", "SELECT", "TEXTAREA"]

let lastInteraction = 0
let pending = false
let idleTimer = null

function overlayOpen() {
  return Array.from(document.querySelectorAll(BLOCKING_OVERLAY)).some(isVisible)
}

function busy() {
  if (document.querySelector(SELECTED)) return true
  if (EDITABLE.includes(document.activeElement?.tagName)) return true
  if (Date.now() - lastInteraction < LULL) return true

  return overlayOpen()
}

function applyPending() {
  if (!pending) return
  if (busy()) return scheduleRetry()
  pending = false
  window.Turbo.session.refresh(document.baseURI)
}

function scheduleRetry() {
  clearTimeout(idleTimer)
  idleTimer = setTimeout(applyPending, LULL)
}

export function requestRefresh() {
  pending = true
  applyPending()
  if (pending) scheduleRetry()
}

export function startRefreshGate() {
  const noteInteraction = () => {
    lastInteraction = Date.now()
    scheduleRetry()
  }

  BUSY_EVENTS.forEach((name) => document.addEventListener(name, noteInteraction, { passive: true }))

  document.addEventListener("turbo:before-stream-render", (event) => {
    if (event.detail.newStream?.action !== "refresh") return

    if (!busy()) return

    event.preventDefault()
    pending = true
    scheduleRetry()
  })
}
